import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import InsightAreaViewItemDetails from "./InsightAreaViewItemDetails"
import PlaceholderImageViewWidget from "../../../common/PlaceholderImageViewWidget"
import ConceptMappingsViewWidget from "../../../common/concept-mappings/ConceptMappingsViewWidget"
import InsightAreaMediaViewWidget from "./InsightAreaMediaViewWidget"
import InsightAreaPermissionHoldersViewWidgetContainer from "./InsightAreaPermissionHoldersViewWidgetContainer"
import InsightAreaViewFingerprintWidgetContainer from "./InsightAreaViewFingerprintWidgetContainer"

const InsightAreaViewItem = ({ model, isFetching }) => (
    <ItemDetailsColumns className="insight-area-item-container">
        <ItemDetailsColumn>
            <InsightAreaViewItemDetails
                name={model.name}
                description={model.description}
                status={model.status}
                type={model.type}
                imageUrl={model.image_url}
                isFetching={isFetching}
            />
            <div className="article-placeholders">
                <PlaceholderImageViewWidget
                    placeholders={model.placeholders}
                    isFetching={isFetching}
                />
            </div>
            <div className="permission-holders">
                <InsightAreaPermissionHoldersViewWidgetContainer
                    isFetching={isFetching}
                />
            </div>
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <div id="topics-mappings">
                <ConceptMappingsViewWidget
                    mappings={model.mappings}
                    isFetching={isFetching}
                />
            </div>
            <InsightAreaViewFingerprintWidgetContainer topicId={model.id} />
            <InsightAreaMediaViewWidget />
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default InsightAreaViewItem
